import React from "react";
import SelectBox from "devextreme-react/select-box";
import TextBox from "devextreme-react/text-box";
import NumberBox from "devextreme-react/number-box";
import { Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { setUIData } from "../../redux/slices/uiSlice";
import DateBox from "devextreme-react/date-box";
import { fromCustomDate, toCustomDate } from "../../utils/date";
import TextArea from "devextreme-react/text-area";
import useResources from "../../hooks/useResources";
import CustomSelection from "./CustomSelection";
import ShowVendorsByType from "./ShowVendorsByType";
import { useCallback } from "react";

const CustomCell = ({
  caption,
  disabled,
  dataField,
  type,
  value,
  reduxName,
  resourceName,
  resourcePath,
}) => {
  const dispatch = useDispatch();

  const { vesselSystems } = useResources();

  const handleFieldChange = useCallback(
    (e) => {
      let value = e.value;
      if (!e.value) return;
      if (dataField === "date") value = toCustomDate(e.value);
      return dispatch(
        setUIData({
          name: reduxName,
          value: { [dataField]: value },
        })
      );
    },
    [dataField, dispatch, reduxName]
  );

  const onCustomItemCreating = useCallback(
    (e) => {
      const { text } = e;
      if (text) {
        return dispatch(
          setUIData({
            name: reduxName,
            value: { [dataField]: text },
          })
        );
      }
    },
    [dataField, dispatch, reduxName]
  );

  return (
    <Grid item xs={12}>
      {caption} :
      {type === "date" && (
        <DateBox
          disabled={disabled}
          displayFormat="dd/MM/yyyy"
          onValueChanged={handleFieldChange}
          value={fromCustomDate(value)}
        />
      )}
      {type === "select" && (
        <>
          <CustomSelection
            disabled={disabled}
            resourceName={resourceName}
            resourcePath={resourcePath}
            value={value}
            placeholder={caption}
            valueExpr="name"
            displayExpr="name"
            handleChange={handleFieldChange}
          />
        </>
      )}
      {type === "vesselSelect" && (
        <div style={{ display: "flex", alignItems: "stretch", width: "100%" }}>
          {caption === "Type" && <ShowVendorsByType type={value} />}
          <SelectBox
            acceptCustomValue={true}
            style={{ width: "100%" }}
            disabled={disabled}
            onValueChanged={handleFieldChange}
            dataSource={Object.values(vesselSystems || {}).filter(
              (system) => system.type === dataField?.toUpperCase()
            )}
            onCustomItemCreating={onCustomItemCreating}
            valueExpr="description"
            displayExpr="description"
            searchEnabled={true}
            defaultValue={value}
            value={value}
            placeholder={caption}
          />
        </div>
      )}
      {type === "text" && (
        <TextBox
          disabled={disabled}
          inputAttr={{ name: dataField, autocomplete: dataField }}
          onValueChanged={handleFieldChange}
          placeholder={caption}
          value={value}
        />
      )}
      {type === "number" && (
        <NumberBox
          disabled={disabled}
          onValueChanged={handleFieldChange}
          placeholder={caption}
          value={value}
        />
      )}
      {type === "textarea" && (
        <TextArea
          disabled={disabled}
          height={100}
          onValueChanged={handleFieldChange}
          placeholder={caption}
          value={value}
        />
      )}
    </Grid>
  );
};

export default CustomCell;
